import { AbstractControl } from '@angular/forms';
import { isFormControl } from '@app/util';
import { ValdrControlValidator, ValdrError, ValdrNamedValidator } from '@app/valdr/models';
import { capitalize } from '@app/valdr/util';
import { isBoxed, unbox } from 'ngrx-forms';
import * as R from 'ramda';

const getValidatorName = (name: string) => `valdr${capitalize(name)}`;

type CreateValidator = (validator: ValdrNamedValidator) => ValdrControlValidator;

/**
 * Creates new control validator that can be used in both reactive forms and ngrx forms.
 *
 * @param {ValdrNamedValidator} - validator config.
 * @param {AbstractControl | any} control - Reactive form control or value.
 * @return {ValdrError | null} - Error if the control is invalid and null otherwise.
 */
export const createValidator: CreateValidator = R.curry((
  {validate, name, config, propertyName}: ValdrNamedValidator,
  control: AbstractControl | any
): ValdrError | null => {
  const value = isFormControl(control) ? control.value : (isBoxed(control) ? unbox(control) : control);

  if (!validate(config, value)) {
    const params = {
      ...R.omit(['message'], config),
      propertyName,
      controlValue: value
    };

    return {
      [getValidatorName(name)]: {
        message: config.message,
        valid: false,
        invalid: true,
        params
      }
    };
  }

  return null;
});
